export { GeneaCommonModule } from './common.module';

export { RouteDataService } from './route-data/route-data.service';
export { RouteData } from './route-data/route-data';